import React from 'react';

import type { Dayjs } from 'Utils/dateTime';
import {
  convertDateFormatToDayjs,
  convertUtcToTimezone,
  formatDayjsToString,
  isValidDayjs
} from 'Utils/dateTime';

import { useDateTimeConfigFromConfigSlice } from '@hooks/useDateTimeConfigFromConfigSlice';

type Props = {
  date: Date | string;
  timezone?: string;
  format?: string;
  showTimezone?: boolean;
  useConfigFormat?: boolean;
};

export const DateInfo = ({
  date,
  timezone: targetTimezone,
  format,
  showTimezone = false,
  useConfigFormat = true
}: Readonly<Props>) => {
  const { dateFormat } = useDateTimeConfigFromConfigSlice();

  if (!date) {
    return <span></span>;
  }

  let dayjsDate: Dayjs | null;

  if (targetTimezone) {
    const dateString = typeof date === 'string' ? date : date.toISOString();
    dayjsDate = convertUtcToTimezone(dateString, targetTimezone);
  } else {
    const dateString = typeof date === 'string' ? date : date.toISOString();
    dayjsDate = convertUtcToTimezone(dateString, 'local');
  }

  if (!isValidDayjs(dayjsDate)) {
    return <span></span>;
  }

  let formatted: string;

  if (useConfigFormat && !format) {
    const dayjsDateFormat = convertDateFormatToDayjs(dateFormat);
    formatted = formatDayjsToString(dayjsDate, dayjsDateFormat);
  } else {
    const formatToUse = format ?? 'YYYY-MM-DD';
    formatted = formatDayjsToString(dayjsDate, formatToUse);
  }

  const displayText =
    showTimezone && targetTimezone ? `${formatted} (${targetTimezone})` : formatted;

  return <span>{displayText}</span>;
};
